// src/pages/VippsReturn.jsx
import { useEffect } from "react";

export default function VippsReturn() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("reference") || params.get("ref");

    if (!ref) {
      window.location.replace("/vipps-error?reason=missing_reference");
      return;
    }

    const apiBase = process.env.REACT_APP_API_URL; // f.eks. http://localhost:5000/api
    const url = `${apiBase}/vipps/return?reference=${encodeURIComponent(ref)}`;

    // nyttig logging
    console.log("[VippsReturn] redirecting to backend:", url);

    // la backend gjøre poll+capture og redirecte videre til order-confirmation
    window.location.replace(url);
  }, []);

  return <div>Fullfører Vipps-betalingen…</div>;
}
